import React from 'react';
import { Link as GLink } from 'gatsby';
import { css, Heading } from 'theme-ui';
import rv from '@components/utils/buildResponsiveVariant';

const yourStyle = {
  boxSizing: 'border-box',
  margin: 0,
  minWidth: 0,
  fontFamily: 'Inter, sans-serif',
  lineHeight: 1.33,
  display: 'block',
  color: 'var(--theme-ui-colors-heading, #101828)',
  textDecoration: 'none',
  '-webkit-text-decoration': 'none',
  fontSize: ['3rem', '2.25rem', '2.25rem', '3rem', '3rem', '3rem'],
  fontWeight: 900,
};

const styles = {
  title: {
    boxSizing: 'border-box',
    margin: 0,
    minWidth: 0,
    fontFamily: 'Inter, sans-serif',
    lineHeight: 1.33,
    display: 'block',
    color: 'var(--theme-ui-colors-heading, #101828)',
    textDecoration: 'none',
    '-webkit-text-decoration': 'none',
    fontSize: ['3rem', '2.25rem', '2.25rem', '3rem', '3rem', '3rem'],
    fontWeight: 900,
  },
  card: {
    boxSizing: 'border-box',
    margin: 0,
    minWidth: 0,
    fontFamily: 'Inter, sans-serif',
    lineHeight: 1.33,
    display: 'block',
    color: 'var(--theme-ui-colors-heading, #101828)',
    textDecoration: 'none',
    '-webkit-text-decoration': 'none',
    fontSize: '20px',
    fontWeight: 600,
    mb: '0.5rem',
  },
};

const CardBodyTitle = ({ variant, title, slug, link }) => {
  const linkProps = link
    ? {
        as: 'a',
        href: link,
        target: '_blank',
        rel: 'noopener noreferrer',
      }
    : {
        as: GLink,
        to: slug,
      };

  const CardBodyTitleWrapper = ({ children }) =>
    variant.includes('cards.horizontal-hero') ? (
      <Heading as={'h1'}>{children}</Heading>
    ) : (
      <>{children}</>
    );

  return (
    <Heading {...linkProps} sx={{ variant: rv(variant, 'title') }}>
      {title}
    </Heading>
  );
};

export default CardBodyTitle;
